import React, { useState, useEffect } from "react";
import Header from "../headers/header";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../contexts/theme";
import FormatLineChart from "../../visualizations/FormatLineChart";
import { GetPastData } from "../../forge/main";
import { GetCurrentTime } from "../global/GetCurrentTime";
import convertToKST from "../global/convertToKST";
import DatePicker from "../global/DatePicker";

const AirQuality = ({ urn }) => {
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const tunnel1 = 257589;
  const tunnel2 = 257558;

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const primaryColor = colors.primary[400];
  const redAccentColor = colors.redAccent[300];
  const [bgColor1, setBgColor1] = useState(primaryColor);
  const [bgColor2, setBgColor2] = useState(primaryColor);

  const title_str = "AIR QUALITY";
  const subtitle_str = [
    `PM1, PM2.5, PM10의 수치를 나타냅니다 (단위: µg/m³). 총 2개 센서로부터 데이터를 받습니다.`,
  ];

  const DataChange = (lists) => {
    let ret = [];
    if (lists.length === 0) return ret;

    let pm25 = { id: "PM2.5", color: "hsl(231, 70%, 50%)", data: [] };
    let pm10 = { id: "PM10", color: "hsl(217, 70%, 50%)", data: [] };
    let pm1 = { id: "PM1", color: "hsl(139, 70%, 50%)", data: [] };

    let state = false;

    for (let i = 0; i < lists.length; i++) {
      if (!("Data" in lists[i]) || !("MessageDate" in lists[i])) continue;

      const timestamp = parseInt(lists[i]["MessageDate"].match(/\d+/)[0], 10);
      const date = new Date(timestamp);

      const list_data = lists[i]["Data"].split("|");
      if (list_data.length < 3) continue;

      pm25.data.push({ x: date, y: Number(list_data[0]) });
      pm10.data.push({ x: date, y: Number(list_data[1]) });
      pm1.data.push({ x: date, y: Number(list_data[2]) });

      if("State" in lists[i] && lists[i]["State"] === 2){
        state = true;
      }
    }
    ret.push(pm25, pm10, pm1);

    return {data: ret, state};
  };

  useEffect(() => {
    const [Tfrom, Tto] = GetCurrentTime();
    const KSTfrom = convertToKST(Tfrom);
    const KSTto = convertToKST(Tto);
    setFrom(KSTfrom);
    setTo(KSTto);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await GetPastData(tunnel1, from, to);
        const response2 = await GetPastData(tunnel2, from, to);

        // if (response1.Result.length === 0) {
        //   alert(`Tunnel-1에서 ${from} - ${to}에 측정된 데이터가 없습니다.`);
        // }
        // if (response2.Result.length === 0) {
        //   alert(`Tunnel-2에서 ${from} - ${to}에 측정된 데이터는 없습니다.`);
        // }
        const d1 = DataChange(response1.Result);
        const d2 = DataChange(response2.Result);

        setData1(d1.data);
        setData2(d2.data);

        setBgColor1(d1.state ? redAccentColor : primaryColor);
        setBgColor2(d2.state ? redAccentColor : primaryColor);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (from && to) {
      fetchData();
    }
  }, [from, to, primaryColor, redAccentColor]);

  return (
    <div>
      <Header title={title_str} subtitle={subtitle_str} />
      <Box>
        <DatePicker from={from} to={to} setFrom={setFrom} setTo={setTo} />
      </Box>
      <Box className="main-box" backgroundColor={bgColor1}>
        <Box className="main-box-detail">
          <Box>
            <Typography variant="h3" fontWeight="600" color={colors.grey[100]}>
              Tunnel-1 공기질 데이터
            </Typography>
          </Box>
        </Box>
        <Box className="main-box-graph">
          {data1 && (
            <FormatLineChart data={data1} is_dashboard={false} y_label={"time"} />
          )}
        </Box>
      </Box>
      <Box className="main-box" backgroundColor={bgColor2}>
        <Box className="main-box-detail">
          <Box>
            <Typography variant="h3" fontWeight="600" color={colors.grey[100]}>
              Tunnel-2 공기질 데이터
            </Typography>
          </Box>
        </Box>
        <Box className="main-box-graph">
          {data2 && (
            <FormatLineChart data={data2} is_dashboard={false} y_label={"time"} />
          )}
        </Box>
      </Box>
    </div>
  );
};

export default AirQuality;
